import React from "react"
import IconButton from "../IconButton/IconButton"

export function ArchivedToolTip() {
	return (
		<div>
			<div className="flex-container justify-content-start align-items-center">
				<span className="is-static" aria-label="Archived document information">
					Archived
				</span>
				<IconButton
					theme="neutral"
					variant="subtle"
					icon="information-circle--interface-essential"
					onClick={undefined}
					disabled={true}
					tooltipClassName="downloader-download-icon-button-tooltip"
					tooltip="Not required due to re-submission"
					tooltipPlace="left"
					tooltipKey="archived-tooltip"
				/>
			</div>
		</div>
	)
}
